<template>
  <div>
    <tabs
      :niveau="2"
      :links="tabList"
      :level="2"
      :mode="'emitter'"
      :current-tab="tab"
      @changeView="tab = $event"
      class="has-background-light is-border-bottom">
    </tabs>
    <div
      v-if="channel">
      <router-link :to="{name: 'ChannelVue', params: {id: channel.pk}}">
        <div
          class="notification is-warning is-hoverable is-marginless is-min-height-75 is-flex">
          <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium is-underline">
            Canal de vente : {{ channel.name }}
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="tab === 'CREATE_ACCESS'">
      <access-form
        :source-account="account"
        @createdAccess="createdAccess"></access-form>
    </div>
    <div v-else>
      <access-light-list
        :allotments="parentAllotments"
        :accesses="accesses"
        :program="program"
        :lots="lots"
        @updateAccess="$emit('afterUpdateAccess')"
        @deleteAccess="deleteAccess"></access-light-list>
    </div>
  </div>
</template>

<script>
import { Access } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'AccessTabList',
  components: {
    AccessForm: () => import('./AccessForm'),
    AccessLightList: () => import('./AccessLightList')
  },
  mixins: [Access],
  props: {
    account: {
      type: String
    },
    accesses: {
      type: Array
    },
    program: {
      type: [Object, String]
    },
    lots: {
      type: Array
    },
    parentAllotments: {
      type: Array
    },
    channel: {
      type: Object
    }
  },
  data () {
    return {
      tab: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isAdmin']),
    /**
      * tabs
      * @return {array}
      */
    tabList () {
      let tabs = []
      tabs.push({ label: `${this.accesses.length} Mandat(s) ouvert`, link: 'ACCESS_LIST' })
      if (this.isPromoteur && this.isAdmin) {
        tabs.push({ label: `Création nouveau mandat`, link: 'CREATE_ACCESS' })
      }
      return tabs
    }
  },
  created () {
    if (this.isPromoteur && this.isAdmin) {
      this.tab = 'ACCESS_LIST'
    } else {
      this.tab = 'ACCESS_LIST'
    }
  },
  methods: {
    /**
      * emit after create access
      * change tab
      * @param {string}
      */
    createdAccess () {
      this.tab = 'ACCESS_LIST'
      this.$emit('afterCreatedAccess')
    },
    /**
      * delete access
      * @param {string}
      */
    async deleteAccess (pk) {
      let value = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au programme, cette action entrainera également l\'annulation de ses options sur ce programme.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCESS, pk)
          this.$toasted.global.success('Mandat supprimé')
          this.$emit('afterDeleteAccess')
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    }
  }
}
</script>
